import { render, staticRenderFns } from "./ContactPersonSelect.vue?vue&type=template&id=14955f5a&"
import script from "./ContactPersonSelect.vue?vue&type=script&lang=ts&"
export * from "./ContactPersonSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports